import { render, staticRenderFns } from "./AddressOverview.vue?vue&type=template&id=7fb9c26b&scoped=true"
import script from "./AddressOverview.vue?vue&type=script&lang=js"
export * from "./AddressOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb9c26b",
  null
  
)

export default component.exports